/* eslint-disable import/no-named-as-default-member */
import { call, put } from 'redux-saga/effects'
import ItemActions from '../reducers/hasuraItemReducer'
import Hasura from '../config/hasura'

export function* fetchItems({ orderKeys }) {
  try {
    const query = `
      query($firebase_keys: [String!]){
        merchant_invoice_reports(where: {firebase_key: {_in: $firebase_keys}}) {
          firebase_key
          customer_tel
          status
          merchant_discount_rate
          promotion_discount
          promotion_cost_sharing
          voucher_discount_amount: voucher_actual_discount_amount
          subtotal

          merchant_key
          merchant_name
          branch_key
          branch_name

          created_at

          rejected_code
          rejected_description

          name
          quantity
        }
      }
    `
    const variables = { firebase_keys: orderKeys }
    const { merchant_invoice_reports: merchantInvceReports } = yield call(Hasura.execute, query, variables)

    yield put(ItemActions.fetchItemsSuccess(merchantInvceReports))
  } catch (err) {
    yield put(ItemActions.fetchItemsError(err))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/hasuraItemSaga.js